import axios from 'axios';

const defaultURL = 'https://treant.ru';
const storageKey = 'company_server_url';

const GetCompanyServerURL = () => { 
  var url = localStorage.getItem(storageKey);
  if (!url) {
    url = defaultURL
    localStorage.setItem(storageKey, url);
  }
  return url;
}

const companyService = axios.create({
  baseURL: GetCompanyServerURL() + '/api', // Через Nginx
});

// Interceptor для добавления токена в заголовки
companyService.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor для отлова 401 ошибки
companyService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default companyService;